import { format } from 'date-fns';

export const dateFormatter = (isoDate) => {
  return format(new Date(isoDate), 'MMMM d, yyyy');
};

